const namespace = "nigthLimitRestriction";

export const GENERAL_DESCRIPTION = `${namespace}.generalDescription`;
export const DESCRIPTION_WITH_DATE = `${namespace}.descriptionWithDate`;
export const GOT_IT = `${namespace}.gotIt`;
